<template>
  <div class="details-view">
    <cargo-left-right-resize
      v-show="Boolean(action)"
      :left-style="{flex:'none','max-width':'220px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <div style="min-width: 180px;width:100%;height:100%;padding:10px 0px 10px;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :row-data="rowData"
            style="width:100%;height:100%;min-height: 500px;padding-left: 16px;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers" style="flex:none">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <!--返回-->
                  <el-button type="primary" no="1" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <!--新增-->
                  <el-button type="primary" no="2" @click="onAdd()">{{ $t('common.btn.new') }}</el-button>
                  <!--编辑-->
                  <el-button v-show="!isCooperate" :disabled="!editBtnEnabled" type="success" no="3" @click="editHandler('edit')">{{ $t('SeaExport.Edit') }}</el-button>
                  <el-button v-show="isCooperate" type="success" no="4" @click="editHandler('edit')">{{ $t('SeaExport.Edit') }}</el-button>
                  <!--复制-->
                  <el-button type="primary" no="5" @click="copyJobHandler()">{{ $t('SeaExport.Clone') }}</el-button>
                  <!--删除-->
                  <el-button v-show="!isCooperate" :disabled="!deleteBtnEnabled" type="danger" no="6" @click="deleteHandler()">{{ $t('SeaExport.Delete') }}</el-button>
                  <template v-if="forecastApproval && !isCooperate">
                    <!--提交-->
                    <el-button v-show="$checkPermission(['button_SIPREALERT_submit'])" :disabled="!submitBtnEnabled" type="primary" no="7" @click="submitHanlder">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
                    <!--撤回-->
                    <el-button v-show="$checkPermission(['button_SIPREALERT_revoke'])" :disabled="!revokeBtnEnabled" type="primary" no="8" @click="revokeHanlder">{{ $t('Message.Withdraw') }}</el-button>
                    <!--拒绝-->
                    <el-button v-show="$checkPermission(['button_SIPREALERT_reject'])" :disabled="!rejectBtnEnabled" type="primary" no="9" @click="forecastRejectHandler">{{ $t('SeaExport.Refuse') }}</el-button>
                  </template>
                  <!--转正式业务-->
                  <el-button v-show="$checkPermission(['button_SIPREALERT_siReportTransfer']) && !isCooperate" :disabled="!convertToRealEnabled" type="primary" no="10" @click="convertToRealJobHandler()">{{ $t('SeaExport.RegularBusiness') }}</el-button>
                  <!--拒绝-->
                  <el-button v-show="false && !isCooperate" type="primary" no="11" @click="rejectHandler()">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--协作状态: 审核通过-->
                  <el-button v-show="$checkPermission(['button_SIPREALERT_accept']) && isCooperate" no="12" :disabled="!(currentRow && !isEditing && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(currentRow.cooperateStatus))" type="primary" @click="acceptCooperateHandler(1)">{{ $t('SeaExport.PassAudit') }}</el-button>
                  <!--协作状态: 拒绝-->
                  <el-button v-show="$checkPermission(['button_SIPREALERT_reject']) && isCooperate" no="13" :disabled="!(currentRow && !isEditing && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(currentRow.cooperateStatus))" type="primary" @click="rejectHandler(1)">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--变更历史记录-->
                  <el-badge :is-dot="crossTenantDialog.readState" style="margin-left: 5px;">
                    <el-button :disabled="!job.trustFromJob" type="primary" no="14" @click="showChangeHistoryHandler()">{{ $t('SeaExport.ChangeHistory') }}</el-button>
                  </el-badge>
                  <el-button type="success" no="15" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
                </div>
                <div v-show="isNew" style="border-left:none;padding-left:0">
                  <el-button type="success" no="16" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button type="success" no="17" @click="cancelEdit(openMultiple?goBackAtMultiple:goBack)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
                <div v-show="action==='edit'" style="border-left:none;padding-left:0">
                  <el-button type="success" no="18" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button type="success" no="19" @click="cancelEdit(openMultiple?againLookAtMultiple:()=>{againShow('look')})">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues2" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                  <span style="font-size:12px;padding: 5px 9px;color:unset;" v-html="commonInfo.title" />
                </div>
              </cargo-button-group-slider>
              <div v-if="action==='look'">
                <!-- im入口 -->
                <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
                <span v-if="forecastApproval" style="font-size:14px;padding: 5px 0;color:#F56C6C">{{ commonInfo.jobTitle }}</span>
                <span style="font-size:12px;padding: 5px 9px;color:unset;" v-html="commonInfo.title" />
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <!--小票-->
              <el-tab-pane
                v-if="!masterFlag"
                :key="1"
                :lazy="true"
                name="basicTab"
                :label="$t('SeaExport.ImportOperation')"
              >
                <basic-tab ref="basicTab" :context="context" :action="action" :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI" :cooperate-edit="cooperateEditOther" :processing-promise-list="processingPromiseList" @containerLoadTypeEvent="containerLoadTypeEvent" />
              </el-tab-pane>
              <!--主票-->
              <el-tab-pane
                v-if="masterFlag"
                :key="2"
                :lazy="true"
                name="masterBasicTab"
                :label="$t('SeaExport.ImportOperation')"
              >
                <master-basic-tab
                  ref="masterBasicTab"
                  :context="context"
                  :action="action"
                  :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                />
              </el-tab-pane>
              <!-- 预报 -->
              <el-tab-pane
                key="tabArrivalInformation"
                :lazy="true"
                name="tabArrivalInformation"
                :label="$t('SeaExport.ArrivalInformation')"
              >
                <tab-arrival-information ref="tabArrivalInformation" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!--费用-->
              <el-tab-pane
                :key="3"
                :lazy="true"
                name="tabCharges"
                :label="$t('SeaExport.Charge')"
              >
                <tab-charges ref="tabCharges" :context="context" :action="action" :is-cross-tenant-se-to-si="isCrossTenantSEToSI" view-source="SiPrediction" />
              </el-tab-pane>
              <!--MBL-->
              <el-tab-pane
                :key="4"
                :lazy="true"
                name="tabMBL"
                label="MB/L"
              >
                <tab-mbl ref="tabMBL" :context="context" :action="action" :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!--HBL-->
              <el-tab-pane
                :key="5"
                :lazy="true"
                name="tabHBL"
                label="HB/L"
              >
                <tab-hbl ref="tabHBL" :context="context" :action="action" :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!--装箱信息-->
              <el-tab-pane
                :key="6"
                :lazy="true"
                name="tabContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-container ref="tabContainer" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!--文件历史-->
              <el-tab-pane
                v-if="!isNew"
                :key="7"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history ref="tabFileHistory" :context="context" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!--拒绝 -->
    <reject-dialog
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :reject-call-back="rejectWindow.rejectCallBack"
    />

    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.totalProfit"
      @callback="estimateValidationDialog.callback"
    />
    <cross-tenant-change-history-dialog v-if="crossTenantDialog.visible" :visible.sync="crossTenantDialog.visible" :data="crossTenantDialog.data" :has-un-read="crossTenantDialog.readState" :job-uuid="job.uuid" :lob="job.lob" />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :editable="cooperationVerifyDialog.editable"
    />
  </div>
</template>

<script>
import { PredictionWorkspaceContext } from './predictionWorkspaceContext'
import { PredictionWorkspacePM } from './predictionWorkspacePM'
import tabHbl from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabHBL'
import tabMbl from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabMBL'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import basicTab from '@/views/cargo/v0/SeaImport/components/Prediction/basicTab'
import masterBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTab'
import ChatDialog from '@/components/Cargo/Common/CargoIm/chatDialog'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TabError } from '@/utils/class/TabError'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { saveSeaBookingSpace, preVerifyReject } from '@/api/SeaImport/seaImportJob'
import { batchUpdatePreVerifyState, updateJobs } from '@/api/booking/job'
import { ensureExecuteSuccess, deepCopy, sleep, getConfigBoolValue, MarkManage } from '@/utils/commonUtil'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import rejectDialog from '@/views/cargo/v0/SeaImport/components/Prediction/opVerifyFrameRejectDialog'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import estimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import tabContainer from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabContainer'
import CrossTenantChangeHistoryDialog from '@/components/Cargo/Job/crossTenantDialogChangeHistory'
import { queryCrossTenantSyncHistory } from '@/api/booking/job'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import { Company } from '@/class/model/mdm/Company'
import tabArrivalInformation from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabArrivalInformation'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'

export default {
  name: 'PredictionWorkspace',
  components: {
    CrossTenantChangeHistoryDialog,
    tabHbl,
    tabMbl,
    tabCharges,
    basicTab,
    tabContainer,
    masterBasicTab,
    tabFileHistory,
    rejectDialog,
    cargoLeftRightResize,
    cargoTemplateSelectorDialog,
    CargoButtonGroupSlider,
    estimateValidationDialog,
    cooperationVerifyDialog,
    ChatDialog,
    CargoIm,
    tabArrivalInformation
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    openMultiple: {
      type: Boolean,
      default: false
    },
    useOrderCenterMode: { type: Boolean, default: false },
    approveCooperationBusiness: { type: Boolean, default: false }
  },
  data() {
    return {
      URL,
      imCacheKey: '',
      selectTypeNames: TYPE_NAMES,
      context: new PredictionWorkspaceContext(this.parentContext),
      pm: new PredictionWorkspacePM(this),
      action: '',
      markManage: new MarkManage(),
      forecastApproval: false, // 是否用预报审批流程
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Payment.businessNumber'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 200,
          tooltip: (params) => {
            return params.data ? params.data.jobNo : ''
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return `<span>${params.value}</span>`
            }
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onCellClicked: async event => {
          const multipleJobViewMode = Number(this.config.get('MultipleJobViewMode')) || 0
          // 双击检测
          if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
            const mark = this.markManage.regenerateMark('onCellClicked')
            await sleep(500)
            if (this.markManage.readMark('onCellClicked') !== mark) {
              return
            }
          }
          this.onCellClicked(event)
          this.getImGroupFunc(event)
        },
        onCellDoubleClicked: event => {
          const multipleJobViewMode = Number(this.config.get('MultipleJobViewMode')) || 0
          if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
            // 中断单击处理
            this.markManage.regenerateMark('onCellClicked')
            this.onCellDoubleClicked(event)
          }
        }
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      isRefresh: false,
      activeTabName: '',
      commonInfo: {
        jobTitle: '',
        title: ''
      },
      rejectWindow: {
        visible: false,
        jobNo: '',
        rejectCallBack: null
      },
      estimateValidationDialog: { // 利润
        visible: false,
        job: {
          estimateAccountsReceivable: 0,
          estimateAccountsPayable: 0,
          estimateGrossProfit: 0,
          situation: ''
        },
        estimateProfitRate: 0,
        totalProfit: 0,
        callback: () => {}
      },
      loading: false,
      crossTenantDialog: {
        visible: false,
        readState: false,
        data: []
      },
      isCrossTenantSEToSI: false,
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaImportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      SystemConstants,
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true
      },
      processingPromiseList: [], // 正在处理中的异步操作对象列表
      sopTemplateConfig: {} // SOP模板配置
    }
  },
  computed: {
    office() {
      return this.context.office
    },
    config() {
      return this.context.config
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    job() {
      return this.currentRow
    },
    sideBar() {
      return this.$store.getters.sidebar.opened
    },
    editBtnEnabled() {
      if (this.forecastApproval) {
        return this.currentRow && (this.currentRow.preverifyState === 3 || this.currentRow.preverifyState === 4 || this.currentRow.preverifyState === 6)
      }
      return true
    },
    deleteBtnEnabled() {
      if (this.forecastApproval) {
        return this.currentRow && (this.currentRow.preverifyState === 3 || this.currentRow.preverifyState === 6 || this.currentRow.preverifyState === 4)
      }
      return true
    },
    submitBtnEnabled() {
      return this.currentRow && (this.currentRow.preverifyState === 3 || this.currentRow.preverifyState === 4 || this.currentRow.preverifyState === 6)
    },
    revokeBtnEnabled() {
      return this.currentRow && (this.currentRow.preverifyState === 0 || this.currentRow.preverifyState === 1)
    },
    rejectBtnEnabled() {
      return this.currentRow && (this.currentRow.preverifyState === 0 || this.currentRow.preverifyState === 1)
    },
    convertToRealEnabled() {
      if (this.forecastApproval) {
        return this.currentRow && (this.currentRow.preverifyState === 0 || this.currentRow.preverifyState === 1)
      }
      return true
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus === undefined || this.paramsOfTab.cooperateStatus === null ? -1 : this.paramsOfTab.cooperateStatus
      if (this.paramsOfTab.cooperateCooperateStatus) {
        cooperateStatus = this.paramsOfTab.cooperateCooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperateBusinessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作业务
      console.log('this.paramsOfTab.cooperateUuid', this.paramsOfTab.cooperateUuid)
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.paramsOfTab.cooperateUuid) {
        return true
      }
      return false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await sleep(1000)
        this.forecastApproval = await getConfigBoolValue('ForecastApprovalSI')
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.loadConfigData()
    getSopTemplateConfig({ lob: 'SI' }).then(res => {
      this.sopTemplateConfig = res.data
    })
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      this.isCrossTenantSEToSI = false
      this.loading = getLoading()
      this.selectedRow = selectedRow
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      this.action = action
      if (!this.activeTabName) {
        this.paramsOfTab.masterFlag = this.currentRow.masterFlag = selectedRow.masterFlag
      }
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      if (selectedRow.uuid) {
        this.rowData = rowData
      } else {
        this.context.opDepartment = null
        await Promise.all([this.context.getDefaultSeaImportJob(), this.context.getOpDepartment(this.office)])
        await this.buildNewRow(selectedRow)
        selectedRow.jobState = -1
        if (!Object.prototype.hasOwnProperty.call(selectedRow, 'path')) selectedRow.path = ''
        this.rowData = [...rowData, selectedRow]
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.loading.close()
        this.setGridSelect(selectedRow)
        await this.onRowClicked({ data: selectedRow })
      })
      if (action === 'look') {
        this.getImGroupFunc({ data: selectedRow })
      }
    },
    // 加载配置项
    loadConfigData() {
    },
    // 新增时 填充默认值
    async buildNewRow(row) {
      // 填充默认值
      new SeaImportJob(row).fillDefaultValue()
      row.path = ''
      row.lob = 'SI'
      row.booking = true // 默认勾选订舱
      row.cargoType = 'GC'
      row.cargoSource = 'NC'
      row.typeHBL = 1
      row.typeMBL = 1
      const l = getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
      if (l && l.length > 0) {
        row.freightTermHBL = l[0].code
      }
      row.portCode = this.$t('SeaExport.PlsSeeEIR')
      row.paymentTermHBL = 'PP'
      row.paymentTermMBL = 'PP'
      row.opOffice = this.office.officeId
      row.taxNature = 0
      Object.assign(row, this.context.defaultSeaImportJob)
      // 进口 目的港=卸货港 ，默认赋值 避免主票上新增小票 生成warehouseNo 用到目的港code
      if (!row.destinationPortCode) {
        row.destinationPortCode = row.dischargingPortCode
      }
      // CARGO-53866 东丽 新增复制业务 销售默认带入当前登录人
      await JobUtils.loadingDlwlSales(row, this)
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getRenderedNodes()
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid || item.data.jobUuid
        const rowKey = row.uuid || row.jobUuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          break
        }
      }
    },
    // 重置行数据
    reset(rows) {
      for (const row of rows) {
        // 标识为脏数据
        row.version = 0
        // 重置子表数据
        for (const key in row) {
          if (typeof row[key] === 'object') {
            row[key] = ''
          }
        }
        row.isCompleteRow = false
      }
    },
    onCellClicked(event) {
      this.changeJob(event)
    },
    onCellDoubleClicked(event) {
      const data = event.data
      if (this.openMultiple && data.jobNo === this.$route.query.key) {
        return
      }
      this.gridApi.setRowData(this.rowData)
      this.setGridSelect(this.currentRow)
      if (this.viewJobNoSet.has(data.jobNo)) {
        this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: data.jobNo }})
      } else {
        if (this.viewJobNoSet.size + 1 > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        const rowData = deepCopy(this.rowData)
        this.reset(rowData)
        this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: data.jobNo }, params: { rowData, activeTabName: this.activeTabName }})
      }
    },
    // 左侧列表切换job
    changeJob(event) {
      const result = event.data
      if (this.openMultiple) {
        if (result.jobNo === this.$route.query.key) {
          return
        }
        this.gridApi.setRowData(this.rowData)
        this.setGridSelect(this.currentRow)
        if (this.viewJobNoSet.has(result.jobNo)) {
          this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: result.jobNo }})
        } else {
          if (Number(this.config.get('MultipleJobViewMode')) === 2) {
            const rowData = deepCopy(this.rowData)
            this.reset(rowData)
            this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: result.jobNo }, params: { rowData, activeTabName: this.activeTabName, replace: true }})
          }
        }
      } else {
        if (this.viewJobNoSet.has(result.jobNo)) {
          this.gridApi.setRowData(this.rowData)
          this.setGridSelect(this.currentRow)
          this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: result.jobNo }})
        } else {
          // 重新数据库中加载job
          result.version = 0
          for (const key in result) {
            if (typeof result[key] === 'object') {
              result[key] = ''
            }
          }
          this.onRowClicked({ data: result })
        }
      }
    },
    // 整拼类型切换
    containerLoadTypeEvent(data) {
      if (this.masterFlag) {
        this.activeTabName = 'masterBasicTab'
      } else {
        this.activeTabName = 'basicTab'
      }
      // 清空pendTabSet.size 用于刷新
      this.pendTabSet = new Set()
      this.handleTabClick()
    },
    // 行点击
    async onRowClicked(event) {
      this.loading = getLoading()
      if (!event.data) {
        this.loading.close()
        return
      }
      this.currentRow = null
      const job = event.data
      const jobVersion = job.version
      // 若选中提单拆并单,则需要找到其父级job
      if (job.dataType && Number(job.dataType) !== 1 && Number(job.dataType) !== 2 && job.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === job.jobUuid) {
            this.currentRow = item
            break
          }
        }
        this.setGridSelect(this.currentRow)
      } else {
        // 本身选中就是job
        this.currentRow = job
      }
      let loadCooperate = false
      // 加载job详细信息
      const jobModel = new SeaImportJob(this.currentRow)
      if (this.currentRow.uuid) {
        if (!jobVersion || jobVersion === 0) this.currentRow.version = 0
        await jobModel.loadJobRelated({
          job: true,
          lclSlaves: this.currentRow.masterFlag,
          charges: true,
          seaEQ: true,
          warehouseIn: this.currentRow.masterFlag,
          warehouseInfo: true,
          trucking: true,
          lclMaster: !this.currentRow.masterFlag,
          seaCargoDoc: !this.currentRow.masterFlag,
          containerUsages: true,
          containers: true,
          surchargeTerms: !this.currentRow.masterFlag,
          orderCenterMode: this.useOrderCenterMode,
          cooperateBranchId: this.cooperateBranchId
        })
        loadCooperate = true
        if (!this.currentRow.path) {
          this.setBasicData(this.currentRow)
          this.gridApi.refreshCells({ force: true })
        }
        this.checkCrossTenantSEToSI()
        this.loadCrossTenantSyncHistory()
      } else {
        jobModel.lclSlaves = jobModel.lclSlaves || []
        jobModel.charges = jobModel.charges || []
      }
      // 协作分公司信息
      if (this.useOrderCenterMode) {
        if (loadCooperate && job.cooperate && job.cooperate.uuid) {
          console.log('job.cooperate===', job.cooperate)
          // 记录原值
          job.opOffice_original = job.opOffice // 分公司
          job.op_original = job.op // 操作
          job.csr_original = job.csr // 客服
          job.overseaOp_original = job.overseaOp // 海外操作
          job.dc_original = job.dc // 单证
          job.planner_original = job.planner // 航线负责人
          job.opDepartment_original = job.opDepartment // 操作部门
          //
          job.opOffice = job.cooperate.branchId // 分公司
          job.op = job.cooperate.opId // 操作
          job.csr = job.cooperate.csrId // 客服
          job.overseaOp = job.cooperate.overseaOp // 海外操作
          job.dc = job.cooperate.dcId // 单证
          job.planner = job.cooperate.planner // 航线负责人
          job.opDepartment = job.cooperate.opDepartment // 操作部门
          JobUtils.convertJobFromCooperateInfo(job, job.cooperate)
          //
          job.cooperateUuid = job.cooperate.uuid
          job.cooperateCooperateStatus = job.cooperate.cooperateStatus
          job.cooperateBusinessType = job.cooperate.businessType
          job.cooperateBranchId = job.cooperate.branchId
          job.cooperateOpId = job.cooperate.opId
          job.cooperateCsrId = job.cooperate.csrId
          job.cooperateOverseaOp = job.cooperate.overseaOp
          job.cooperateDcId = job.cooperate.dcId
          job.cooperatePlanner = job.cooperate.planner
          job.cooperateOpDepartment = job.cooperate.opDepartment
          job.cooperateSales = job.cooperate.sales
          job.cooperateCargoSalesId = job.cooperate.cargoSalesId
          job.cooperateUserDefinedRoleId1 = job.cooperate.userDefinedRoleId1
          job.cooperateUserDefinedRoleId2 = job.cooperate.userDefinedRoleId2
        }
      }
      this.initInfo()
      this.commonInfo.jobTitle = ColumnUtils.getPreverifyStateCN(this.currentRow.preverifyState || 1)
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.processingPromiseList = []
      this.$nextTick(() => {
        if (this.isNew) {
          this.activeTabName = this.getDefaultActiveName()
        } else {
          const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
          if (activePanes && activePanes.length === 0) {
            this.activeTabName = this.getDefaultActiveName()
          }
        }
        this.handleTabClick()
      })
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理
    async endTabHandler(tabName) {
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.loading = getLoading()
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
        this.loading.close()
      })
    },
    // 编辑
    editHandler(action) {
      this.loading = getLoading()
      new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 150)
      }).then(async() => {
        // 协作状态
        if (this.currentRow.cooperateStatus !== -1 && this.useOrderCenterMode && !this.orderCenterBranch && this.approveCooperationBusiness) {
          if (this.currentRow.cooperateStatus !== SystemConstants.COOPERATE_STATUS_APPROVED.code) {
            const cooperateStatusStr = JobUtils.getStateName(this.currentRow.cooperateStatus, SystemConstants.COOPERATE_STATUS)
            this.$message.warning(this.$t('Message.CanNotEditJob', [this.$t('CargoMsg.Cargo_CooperateStatus') + cooperateStatusStr]))
            this.loading.close()
            return
          }
          this.loading.close()
          this.againShow(action)
          return
        }
        if (this.currentRow.jobState > -1) {
          this.$message.warning(this.$t('Message.PromissoryNoteIsAFormalBusiness'))
          this.loading.close()
          return
        }
        if (!await SecurityUtil.canEdit(new SeaImportJob(this.currentRow))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          this.loading.close()
          return
        }
        this.againShow(action)
      })
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      this.loading = getLoading()
      const selectedRow = this.isNew ? row || {} : this.currentRow
      this.onShow(action, this.rowData, selectedRow)
    },
    // 保存海运进口业务【保存业务相关数据】
    async save() {
      if (this.processingPromiseList.length > 0) {
        const processingPromiseList = [...this.processingPromiseList]
        for (const processingPromise of processingPromiseList) {
          try {
            await processingPromise
          } catch (err) {
            console.log(err)
          }
        }
      }
      // 当前页签结束后的处理
      if (this.activeTabName) {
        await this.endTabHandler(this.activeTabName)
      }
      const body = {}
      try {
        for (const item of [...this.pendTabSet, 'other']) {
          let tabData = null
          if (item !== 'other') {
            // 各页签的保存数据
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              /* 获取各页签需要保存的数据 */
              const result = this.$refs[item].getSubmitData()
              if (result instanceof Promise) {
                tabData = await result
              } else {
                tabData = result
              }
            }
          } else {
            // 被联动修改了的数据
            tabData = this.context.modifiedData
          }

          if (!tabData) continue
          // this.$logger.log('tabData' + item, tabData)
          // 将不同页签相同key的集合进行数据合并
          for (const key in tabData) {
            const tabValue = tabData[key]
            // this.$logger.log('tabValue：' + item, tabValue)
            if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
            const bodyValue = body[key]
            // this.$logger.log('bodyValue：' + item, bodyValue)
            if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
            // 将数组进行合并
            if (Array.isArray(tabValue)) {
              if (Array.isArray(bodyValue)) { // 这里面会将 uuid 相同的费用进行过滤，页签上的优先于 级联改动的数据
                const bodyMap = new Map()
                if (bodyValue && bodyValue.length > 0) {
                  for (const bodyKey of bodyValue) {
                    if (!bodyKey) continue
                    if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                  }
                }
                if (tabValue && tabValue.length > 0) {
                  for (const tabKey of tabValue) {
                    if (!tabKey || bodyValue.includes(tabKey)) continue
                    if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                    bodyValue.push(tabKey)
                  }
                }
              } else {
                tabValue.push(bodyValue)
                body[key] = tabValue
              }
              delete tabData[key]
            }
          }
          Object.assign(body, tabData)
        }
        // 还原接单分公司
        if (this.useOrderCenterMode) {
          if (body.job && body.job.cooperateUuid) {
            body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
            body.job.op = body.job.op_original || body.job.op // 操作
            body.job.csr = body.job.csr_original || body.job.csr // 客服
            body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
            body.job.dc = body.job.dc_original || body.job.dc // 单证
            body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
            body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
            JobUtils.restoreJobFromCooperateInfo(body.job)
          }
        }
        // 清空子表数据【原本是在各页签里面的，现在移到公共的地方来】
        if (Reflect.has(body, 'job') && body.job) {
          for (const key in body.job) {
            // 这里必须要删除，不能将其置为空或者undefined，否则复制或者拆分主票没法赋值
            if (typeof body.job[key] === 'object') delete body.job[key]

            // 保存时需要将sop显示列排除
            if (key.indexOf('_sop_') !== -1 && key.startsWith('_sop_')) delete body.job[key]
          }
        }
        this.doNotClickTabData(body)
        this.cleanCircleObject(body)
      } catch (err) {
        this.loading.close()
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
      // 在保存前进行校验
      const bodyJob = body.job || null
      if (!(await this.pm.checkBeforeSave(bodyJob))) {
        this.loading.close()
        return
      }

      // 保存业务时判断缓存M单和H单的提单方式是否变更
      if (body.seaCargoDoc && Number(this.config.get('ReleaseTypeDefaultValue')) === 4) {
        for (const doc of body.seaCargoDoc) {
          if (doc.docType === 'MBL') {
            const type = LocalStorageUtilsNew.getConfiguration('SI_MBL_BL_MODEL')
            if (doc.releaseType && doc.releaseType !== type) {
              LocalStorageUtilsNew.setConfiguration('SI_MBL_BL_MODEL', doc.releaseType)
            }
          } else if (doc.docType === 'HBL') {
            const type = LocalStorageUtilsNew.getConfiguration('SI_HBL_BL_MODEL')
            if (doc.releaseType && doc.releaseType !== type) {
              LocalStorageUtilsNew.setConfiguration('SI_HBL_BL_MODEL', doc.releaseType)
            }
          }
        }
      }

      // 若为自揽货 清空指定货代理取值
      if (body.job && body.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        body.job.designationAgent = 0
      }

      // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
      await SopUtil.checkSopTemplate(bodyJob, this, null, null, this.sopTemplateConfig)
      if (bodyJob.masterFlag) {
        bodyJob.jobState = -1
        if (bodyJob.lclSlaves && bodyJob.lclSlaves.length > 0) {
          for (const s of bodyJob.lclSlaves) {
            s.carrierId = bodyJob.carrierId
            s.vessel = bodyJob.vessel
            s.voyageFlight = bodyJob.voyageFlight
            s.mbl = bodyJob.mbl
            s.eta = bodyJob.eta
            s.etd = bodyJob.etd
            s.releaseTypeMBL = bodyJob.releaseTypeMBL
            s.paymentTermMBL = bodyJob.paymentTermMBL
          }
        }
      }
      this.continueSave(body)
    },
    // 保存 访问数据库
    async continueSave(body) {
      body.action = this.action
      if (this.forecastApproval && (body.action === 'add' || body.action === 'copy')) {
        body.job.preverifyState = 4
      }
      this.loading = getLoading()
      await saveSeaBookingSpace(body).then(res => {
        const result = res.data.job
        if (result) {
          Object.assign(this.currentRow, result)
          this.currentRow.version = 0
          this.currentRow.jobUuid = result.uuid
          this.currentRow.dataType = result.masterFlag ? 1 : 2 // 1、主票 1、小票
          if (this.currentRow.lclMasterUuid) {
            if (this.openMultiple && !this.rowData.some(p => p.uuid === this.currentRow.lclMasterUuid)) {
              this.currentRow.path = result.uuid
            } else {
              this.currentRow.path = result.lclMasterUuid + ',' + result.uuid
            }
          } else {
            this.currentRow.path = result.uuid
          }
          this.isRefresh = true
        }
        // 重置子表数据【将job相关信息置空，然后从库里重新加载】
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
      }).catch((e) => {
        this.loading.close()
        this.$message.error(e.message)
      })
      // 保存成功后各业签执行的回调方法
      for (const item of this.pendTabSet) {
        const executeTask = this.$refs[item].executeTask
        if (executeTask && typeof executeTask === 'function') {
          const result = this.$refs[item].executeTask()
          if (result instanceof Promise) {
            await result
          }
        }
      }
      this.loading.close()
      if (this.openMultiple) {
        if (this.gridApi) this.gridApi.refreshCells({ force: true })
        if (this.currentRow.jobNo !== this.$route.query.key) {
          const rowData = deepCopy(this.rowData)
          this.reset(rowData)
          this.$message.success(this.$t('Message.SaveSuccessfully'))
          this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: this.currentRow.jobNo }, params: { rowData, replace: true }})
          return
        }
        await this.againShow('look', this.currentRow)
      } else {
        await this.againShow('look', this.currentRow)
        if (JobUtils.isBlockJob(this.currentRow)) {
          setTimeout(() => {
            this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
          }, 2000)
        }
      }
      this.$message.success(this.$t('Message.SaveSuccessfully'))
    },
    // 复制
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const job = this.currentRow
      if (!body || !job || !isCopy) return
      if (!Object.prototype.hasOwnProperty.call(body, 'charges') && job.charges && job.charges.length > 0) {
        Object.assign(body, { charges: job.charges })
      }
      if (!Object.prototype.hasOwnProperty.call(body, 'trucking') && job.trucking && job.trucking.length > 0) {
        Object.assign(body, { truckingInfo: job.trucking })
      }
      if (!Object.prototype.hasOwnProperty.call(body, 'warehouseInfo') && job.warehouseInfo && job.warehouseInfo.length > 0) {
        Object.assign(body, { warehouseInfo: job.warehouseInfo })
      }
    },
    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    againLookAtMultiple() {
      this.currentRow = this.rowData.find(p => p.jobNo === this.$route.query.key)
      this.againShow('look')
    },
    goBackAtMultiple() {
      this.currentRow = this.rowData.find(p => p.jobNo === this.$route.query.key)
      this.againShow('look')
      this.goBack()
    },
    // 返回
    goBack() {
      this.activeTabName = ''
      this.$store.dispatch('app/setCanCloseModule', true)
      this.$emit('back', this.isRefresh)
    },
    // 打印
    onPrint() {
      if (JobUtils.isBlockJob(this.job)) {
        this.$message.info(this.job.jobNo + this.$t('Message.ItIsLocked'))
        return
      }
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.job.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.job.uuid
        }
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    transferTargetRow(action, jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        if (this.viewJobNoSet.has(selectedRow.jobNo)) {
          this.$router.push({ name: 'SiPrediction', query: { openNew: true, key: selectedRow.jobNo }, params: { action }})
        } else {
          this.onShow(action, this.rowData, selectedRow)
        }
      }
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 复制
    copyJobHandler() {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.$emit('copy', this.currentRow)
    },
    // 删除
    deleteHandler() {
      if (this.viewJobNoSet.has(this.currentRow.jobNo)) {
        this.$message.warning('[' + this.currentRow.jobNo + ']' + this.$t('queryJob.JobOpenedAndCannotDelete'))
        return
      }
      this.$emit('delete', { job: this.currentRow, isInner: true })
    },
    submitHanlder() {
      const loading = getLoading4Cxt(this)
      batchUpdatePreVerifyState([this.currentRow.uuid], 1).then(res => {
        if (res.data && res.data.length > 0) {
          this.currentRow.jobVersion = res.data[0].version
          this.currentRow.preverifyState = res.data[0].preverifyState
        }
        this.againShow('look', this.currentRow)
        this.isRefresh = true
        this.$message.success(this.$t('Message.OperationSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    },
    revokeHanlder() {
      const loading = getLoading4Cxt(this)
      batchUpdatePreVerifyState([this.currentRow.uuid], 4).then(res => {
        if (res.data && res.data.length > 0) {
          this.currentRow.jobVersion = res.data[0].version
          this.currentRow.preverifyState = res.data[0].preverifyState
        }
        this.againShow('look', this.currentRow)
        this.isRefresh = true
        this.$message.success(this.$t('Message.OperationSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    },
    // 预报审批拒绝处理
    forecastRejectHandler() {
      this.rejectWindow.jobNo = this.currentRow.jobNo
      this.rejectWindow.rejectCallBack = this.forecastRejectCallBackHandler
      this.rejectWindow.visible = true
    },
    // 预报审批拒绝回调函数
    forecastRejectCallBackHandler(bookingRefuseNote) {
      const job = {}
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] !== 'object') {
          job[key] = this.currentRow[key]
        }
      }
      job.preverifyState = 3
      job.bookingRefuseNote = bookingRefuseNote
      const loading = getLoading4Cxt(this)
      updateJobs([job], { selectiveType: 'preverifyState,bookingRefuseNote' }).then(res => {
        this.currentRow.version = 0
        this.againShow('look', this.currentRow)
        this.isRefresh = true
        this.$message.success(this.$t('SeaExport.RefuseSuccess'))
      }).finally(() => {
        loading.close()
      })
    },
    // 转正式业务
    convertToRealJobHandler() {
      this.$emit('regularBusiness', { job: this.currentRow, isInner: true })
    },
    // 拒绝
    rejectHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.rejectWindow.jobNo = this.currentRow.jobNo
      this.rejectWindow.rejectCallBack = this.isCooperate ? this.rejectCooperateCallBackHandler : this.rejectCallBackHandler
      this.rejectWindow.visible = true
    },
    // 审核拒绝回调函数
    rejectCallBackHandler(remark) {
      preVerifyReject({ 'jobUuid': this.currentRow.uuid, 'remarks': remark, 'jobVersion': this.currentRow.version }).then(res => {
        this.againShow('look', this.currentRow)
        this.$message.success(this.$t('SeaExport.RefuseSuccess'))
      })
    },
    // 变更历史记录
    showChangeHistoryHandler() {
      this.crossTenantDialog.visible = true
      this.crossTenantDialog.readState = false
    },
    checkCrossTenantSEToSI() {
      const company = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
      if (company && this.job.trustFromJob && company.relateTenantId > 0 && company.relateTenantOfficeId > 0) {
        this.isCrossTenantSEToSI = true
      }
    },
    loadCrossTenantSyncHistory() {
      const jobUuid = this.currentRow.uuid
      if (!jobUuid) {
        return
      }
      queryCrossTenantSyncHistory({ jobKey: jobUuid }).then(res => {
        this.crossTenantDialog.readState = false
        // 判断已读状态
        if (res.data && res.data.length > 0) {
          for (const data of res.data) {
            if (data.receiveJobUuid === jobUuid && !data.readState) {
              this.crossTenantDialog.readState = true
              break
            }
          }
        }
        this.crossTenantDialog.data = res.data
      })
    },
    // 协作状态: 审核通过
    acceptCooperateHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuid = this.currentRow.uuid
      const cooperate = {
        uuid: this.currentRow.cooperateUuid,
        branchId: this.currentRow.cooperateBranchId,
        opId: this.currentRow.cooperateOpId,
        csrId: this.currentRow.cooperateCsrId,
        overseaOp: this.currentRow.cooperateOverseaOp,
        dcId: this.currentRow.cooperateDcId,
        planner: this.currentRow.cooperatePlanner,
        sales: this.currentRow.cooperateSales,
        cargoSalesId: this.currentRow.cooperateCargoSalesId,
        userDefinedRoleId1: this.currentRow.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.currentRow.cooperateUserDefinedRoleId2,
        opDepartment: this.currentRow.cooperateOpDepartment,
        businessType: this.currentRow.cooperateBusinessType ? this.currentRow.cooperateBusinessType.split(',') : [],
        cooperateStatus: this.currentRow.cooperateCooperateStatus
      }
      console.log('cooperate', cooperate)
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.currentRow.cooperateStatus = res.data[0].cooperateStatus
          this.againShow('look', this.currentRow)
          this.isRefresh = true
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.currentRow.cooperateStatus = res.data[0].cooperateStatus
          this.againShow('look', this.currentRow)
          this.isRefresh = true
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', result.dischargingPortCode, 'englishName')}`
      console.log('result===', result)
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        operatorUserId: result.op, // 操作人userId
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data, result)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data, result) {
      console.log('result.customerId======', result)
      let company = { cmpIdx: result.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === result.customerContact) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    saveDefaultVal() {
      const loading = getLoading()
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'SeaImportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    },
    // 加载完job走这里
    initInfo() {
      this.showTitle()
    },
    async showTitle() {
      const job = this.currentRow
      this.commonInfo.title = ''
      if (job.customerId && !job.masterFlag) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await JobUtils.getBillingTypeByCompany(cmp)
          this.commonInfo.title = '<span style="margin-right:10px">' + (this.$store.getters.language === 'zh' ? cmp.chineseName : cmp.englishName) + creditTerm + '</span><span>' + billingType + '</span>'
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
